(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-brand-showcase"] && !Shopify.designMode) return;
  try {
    
  class B2BBrandCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.track = this.querySelector('.b2b-brand-carousel__track');
      this.previous = this.querySelector('[data-brand-carousel-previous]');
      this.next = this.querySelector('[data-brand-carousel-next]');

      if (!this.track || !this.previous || !this.next) return;

      this.previous.addEventListener('click', () => this.slide(-1));
      this.next.addEventListener('click', () => this.slide(1));
      this.initialized = true;
    }

    slide(direction) {
      const card = this.track.querySelector('.b2b-brand-carousel__card');
      if (!card) return;

      const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      const cardWidth = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.round(this.track.clientWidth / cardWidth) - 1);
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= maxScroll - 1;

      if (direction < 0 && atStart) {
        this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        return;
      }

      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      this.track.scrollBy({
        left: direction * cardWidth * visibleCards,
        behavior: 'smooth',
      });
    }
  }

  if (!customElements.get('b2b-brand-carousel')) {
    customElements.define('b2b-brand-carousel', B2BBrandCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b2b-home-carousel]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-b2b-home-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-b2b-home-dot]'));
    const previous = carousel.querySelector('[data-b2b-home-previous]');
    const next = carousel.querySelector('[data-b2b-home-next]');
    let index = 0;
    let timer;

    if (slides.length < 2) return;

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    const show = (nextIndex, shouldRestart) => {
      const total = slides.length;
      index = (nextIndex + total) % total;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (shouldRestart) {
        stop();
        start();
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => show(index + 1, false), 6500);
    };

    previous?.addEventListener('click', () => show(index - 1, true));
    next?.addEventListener('click', () => show(index + 1, true));
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => show(dotIndex, true));
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    carousel.dataset.carouselReady = 'true';
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
